import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  requireSuperadmin?: boolean;
  requireAdminClient?: boolean;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children, requireSuperadmin, requireAdminClient }) => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-gray-500">Chargement...</div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  if (!user.active_client) return <Navigate to="/select-context" replace />;

  if (requireSuperadmin && user.system_role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  if (requireAdminClient
    && user.role_in_active_client !== 'admin_client'
    && user.system_role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
